var React = require('react');

function ArrowLeftGrey (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M18.4012 1.60868e-06L23 3.99937L9.20058 16L23 28.0006L18.4012 32L-1.39899e-06 16.0025L18.4012 1.60868e-06Z","fill":"#585E65"}));
}

ArrowLeftGrey.defaultProps = {"width":"23","height":"32","viewBox":"0 0 23 32","fill":"none"};

module.exports = ArrowLeftGrey;

ArrowLeftGrey.default = ArrowLeftGrey;
